"use client";

import { useLayout, useTheme } from "@/providers";
import { useEffect, useState } from "react";
import ButtonIcon from "./icon";

const ButtonThemeSwitcher = () => {
  const { t } = useLayout();
  const { theme, changeTheme } = useTheme();

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <ButtonIcon
      aria-label={t("alternateThemeMode")}
      action={() => changeTheme(theme === "light" ? "dark" : "light")}
      iconLeft={{
        name: theme === "light" ? "moon:bx" : "sun:bx",
        size: "2x"
      }}
    />
  );
};

export default ButtonThemeSwitcher;
